import React from "react";
import Slider from '@material-ui/core/Slider';

const marks = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
];
class CloseFeedback extends React.Component {
  render() {
    const {
      question,
      leftLegend,
      rightLegend,
      onConfirmAnswer,
      answer,
      id
    } = this.props;

    return (
      <div className="feedback">
        <p className="text-center title">{question}</p>
        <div className="legends">
          <p style={{ float: "left" }}>{leftLegend}</p>
          <p style={{ float: "right" }}>{rightLegend}</p>
        </div>
        <Slider
          min={1}
          max={10}
          value={answer || 5}
          // name={c.name}
          step={1}
          valueLabelDisplay="auto"
          marks={marks}
          color='white'
          onChange={(event, value) =>
            onConfirmAnswer(value, id)

          }
        />
      </div>
    );
  }
}

export default CloseFeedback;
